var map = {
	"./button.svg": 29692,
	"./cascader.svg": 83608,
	"./checkbox.svg": 20659,
	"./color.svg": 90765,
	"./component.svg": 77541,
	"./date-range.svg": 69656,
	"./date.svg": 15772,
	"./input.svg": 65692,
	"./number.svg": 82355,
	"./password.svg": 20731,
	"./radio.svg": 61401,
	"./rate.svg": 53862,
	"./rich-text.svg": 70230,
	"./row.svg": 3852,
	"./select.svg": 95840,
	"./slider.svg": 35815,
	"./switch.svg": 58964,
	"./table.svg": 19212,
	"./textarea.svg": 10974,
	"./time-range.svg": 63427,
	"./time.svg": 63547,
	"./upload.svg": 79027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;